import { Button, Card, Col, Container, DatePicker, Form, FormCheckbox, FormSelect, ListGroup, ListGroupItem, Row } from "shards-react";
import InfoTooltip from "../../../components/common/InfoTooltip";
import { useEffect, useRef, useState } from "react";
import { setAlert } from "../../../redux/actions/alert";
import { validateFileName } from "../../../utils/general";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { setInputDate } from "../../../utils/date";
import { get_worker_import_type, save_import_data } from "../../../redux/actions/worker/import";

function ImportData({
    setAlert,
    importTypeList,
    save_import_data,
    get_worker_import_type,
}) {

    const [formData, setFormData] = useState({
        importType: '',
        importDuplicates: false,
        file: null,
    })
    const [ payPeriodOption, setPayPeriodOption ] = useState([]);

    const [isSubmitting, setSubmitting] = useState(false);
    const fileRef = useRef(null)
    const history = useHistory();

    const importTypeListOptions = (importTypeList || []).map(importType => <option key={importType} value={importType}>{importType}</option>)

    const onChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });
    const resetFile = () => {
        if (fileRef.current) {
            fileRef.current.value = "";
        }
    };
    const onFileChange = (e) => {
        e.preventDefault();
        const supportedExtensions = ['.csv', '.CSV', '.xlsx', '.XLSX'];
        //const supportedExtensions = formData.importType === 'Payroll Tax' ? ['.csv', '.CSV'] : ['.xlsx', '.XLSX'];
        let file = e.target.files[0];
        if(file === undefined) {
            resetFile();
            return;
        }
        let fileExtension = file.name.substring(file.name.lastIndexOf('.'), file.name.length);
        let valid = validateFileName(file.name);

        if (!valid) {
            setAlert("File name should only contain letters [a-z, A-Z], numbers [0-9], space [' '], period [.], underscore [_] and hyphen [-].", "danger");
            resetFile();
            return;
        }
        if (!supportedExtensions.includes(fileExtension.toLowerCase())) {
            setAlert(`Please attach '.CSV' or '.XLSX' only.`, "danger");
            resetFile();
            return;
        }

        setFormData({ ...formData, file: file });
    }

    const onSubmit = async (e) => {
        e.preventDefault();

        if (isSubmitting) return;
        setSubmitting(true);
        const formDataToSubmit = { ...formData };

        formDataToSubmit.startDate = setInputDate(formDataToSubmit.startDate);
        const saved = await save_import_data({ ...formDataToSubmit });
        if(Number(saved) > 0) {
        }
        setSubmitting(false);

    }

    useEffect(() => {
        get_worker_import_type();
    }, [])

    // useEffect(() => {
    //     console.log("importTypeList =>", importTypeList);
    // }, [importTypeList])

    useEffect(() => {
        let url = window.location.href.toString();
        let option = url.substring(url.lastIndexOf('/') + 1, url.length);
        if(option === 'timesheet'){
            setFormData({ ...formData, importType: 'Timesheets - PHRBO Format'})
        }

    }, [importTypeList])

    const getFilePathForImport = (type) => {
        let href = "";
        let fileName = "";

        switch (type) {
            case 'Timesheets - PHRBO Format':
                href = "/sampleFile/Worker/Timesheet-Import-Sample.xlsx";
                fileName = "Timesheet-Import-Sample.xlsx";
                prepareAnchorToDownload(href, fileName);
                break;
            case 'Timesheets - Clockify Format':
                href = "/sampleFile/Worker/Clockify-Time-Report-Detailed.csv";
                fileName = "Clockify-Time-Report-Detailed.csv";
                prepareAnchorToDownload(href, fileName);
                break;
        }
    }

    const prepareAnchorToDownload = (href, name) => {
        const link = document.createElement('a');
        link.href = href;
        link.download = name;
        link.click();
    }

    return (
        <Container fluid className="main-content-container p-4">
            <Card small className="mb-4 w-100 ">
                <ListGroup flush>
                    <Form onSubmit={onSubmit}>
                        <ListGroupItem className="border-card p-3 w-100">
                            <Row className="mb-3 h-100">
                                <Col lg="4" className="d-flex flex-row justify-content-between">
                                    <label htmlFor="importType" className="w-50 mt-2">Import Type</label>
                                    <FormSelect
                                        name="importType"
                                        id="importType"
                                        value={formData.importType}
                                        onChange={onChange}
                                    >
                                        <option key="importType0" value="">Select Import Type</option>
                                        {importTypeListOptions}

                                    </FormSelect>
                                </Col>
                                <Col lg="4" className="d-flex flex-row justify-content-between pl-5">
                                    {formData.importType !== "" ? <Button className="custom-margin-header" onClick={() => {
                                        getFilePathForImport(formData.importType);
                                    }}>
                                        Download Sample File Format
                                    </Button> : <></>}
                                </Col>
                                <Col lg="4" className="d-flex flex-row mt-2 importDataCheckboxAdjustment">
                                    <label htmlFor="importDuplicates" className="w-70">Do not import duplicates</label>
                                    <InfoTooltip cssClassName="text-start custom-tooltip-inner mt-1 mr-5"
                                        msg="For Ceridian Payroll tax: Rows with the same PPE and employee number <br/>that have been already imported will not be imported again." />

                                    <FormCheckbox
                                        name="importDuplicates"
                                        id="importDuplicates"
                                        value={formData.importDuplicates}
                                        checked={formData.importDuplicates}
                                        onChange={() => setFormData({ ...formData, importDuplicates: !formData.importDuplicates })}
                                    />
                                </Col>
                            </Row>
                            
                            <Row className="mb-2 h-100">
                                <Col lg="4" className="d-flex flex-row justify-content-between">
                                    <div>
                                        <label htmlFor="file" className="mt-2 w-50">File Upload</label>
                                        <input name="file" id="file" type="file" onChange={onFileChange} ref={fileRef} accept={'.csv, .xlsx'} />
                                    </div>
                                    <div className="d-flex align-items-end">
                                        <Button >Submit</Button>
                                    </div>

                                </Col>
                            </Row>
                        </ListGroupItem>
                    </Form>
                </ListGroup>
            </Card>
        </Container>
    )
}

const mapStateToProps = (state => ({
    importTypeList: state.workerImport.importTypeList,
}))
export default connect(mapStateToProps, {
    setAlert,
    save_import_data,
    get_worker_import_type,
})(ImportData)